export default __webpack_public_path__ + "static/media/talent-sourcing.0fae18e9.jpg";